import UserApi from '@/services/rest/bemob/user';
import SharedReports from '@/services/rest/bemob/shared-reports';


export class SharedReportsApi {
  loading: boolean = false;
  error: boolean = false;

  data: object = {};
  api: UserApi = new UserApi();
  sharedReportsApi: SharedReports = new SharedReports();

  getSharedReports() {
    // this.loading = true;

    this.sharedReportsApi.get().then(data => this.data = data)
    return Promise.resolve()
  }

  delete(id) {
    return this.sharedReportsApi.delete(id).then(() => this.getSharedReports())
  }

  update(id, params) {
    return this.sharedReportsApi.put(id, params).then(() => this.getSharedReports())
  }

}

export default new SharedReportsApi();
